// Device dimension constants for the offer-page builder editor.
// Extracted from OfferPageBuilderSimple.js. Pure numeric/string constants.
//
// BRANDS_*: scaled device + column widths for ~13" laptop (sidebar + four columns).
// SETUPS_*: scaled device + column widths for ~13" laptop (sidebar + three columns).

export const BRANDS_REF_DEVICE_WIDTH = 414;
export const BRANDS_REF_DEVICE_HEIGHT = 750;
export const BRANDS_EDITOR_DEVICE_WIDTH = 300;
export const BRANDS_EDITOR_DEVICE_HEIGHT = Math.round(
  (BRANDS_REF_DEVICE_HEIGHT * BRANDS_EDITOR_DEVICE_WIDTH) / BRANDS_REF_DEVICE_WIDTH
);
export const BRANDS_EDITOR_LABEL = `${BRANDS_EDITOR_DEVICE_WIDTH}×${BRANDS_EDITOR_DEVICE_HEIGHT}`;
export const BRANDS_PAGE_MAX_HEIGHT = BRANDS_EDITOR_DEVICE_HEIGHT;
export const BRANDS_EDITOR_PREVIEW_COL_WIDTH = 310;
export const BRANDS_EDITOR_RIGHT_PANEL_WIDTH = 280;
export const BRANDS_EDITOR_SAVED_COL_WIDTH = 140;

export const SETUPS_REF_DEVICE_WIDTH = 375;
export const SETUPS_REF_DEVICE_HEIGHT = 667;
export const SETUPS_EDITOR_DEVICE_WIDTH = 310;
export const SETUPS_EDITOR_DEVICE_HEIGHT = 551;
export const SETUPS_EDITOR_LABEL = '310×551';
export const SETUPS_EDITOR_PREVIEW_COL_WIDTH = 340;
